import * as React from 'react';
import MFilesTableView from '../layouts/MFilesTableView';
import { TatData, ManufacturerData, BranchData } from 'src/reducers/fileUpload';
import { Snackbar } from '@material-ui/core';
import { AlertTitle } from '@material-ui/lab';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { LabData } from 'src/reducers/mfileupload';

function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export interface FilesTableProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;

    deleteRowbyId: () => void;
    onUploadAllFiles: () => void;
    onClearAllFiles: () => void;
    onRefreshStatus: () => void;
    onClearAllUploaded: () => void;

    mfilesUpload: Array<File>;
    onFilesChange2: () => void;
    onFilesError2: () => void;
    mprogress: Array<number>;
    msending: boolean;

    onSelectFile: () => void;
    onSelectAllFile: () => void;
    orderDataTat: TatData[];
    orderDataManufacturer: ManufacturerData[];

    mlabData: LabData[];
    mlabChosen: string;
    mbranchData: BranchData[];
    mbranchType: string;

    saveTatType: () => void;
    saveMessegeOrder: () => void;
    saveManufactType: () => void;
    saveDesignSoftware: () => void;
    saveOrderModel: () => void;
    saveDesignApproval: () => void;
    saveIsBravo: () => void;

    saveLabselected: (lab: string) => void;
    saveBranchType: (branchType: string) => void;

    errorMessage: string;
    errorBar: boolean;
    successMessage: string;
    successBar: boolean;
    handleCloseRemovefiles: () => void;

    errorFileUploadedOpen: boolean;
    errorfilemsg: string;
    successFileUploadOpen: boolean;
    successfilemsg: string;
    saveDrPreferences: () => void;
    saveBookingId: () => void;

}

class MFilesTable extends React.Component<FilesTableProps> {
    render() {
        return (
            <div>
                <MFilesTableView
                    deleteRowbyId={this.props.deleteRowbyId}
                    onUploadAllFiles={this.props.onUploadAllFiles}
                    onClearAllFiles={this.props.onClearAllFiles}
                    onRefreshStatus={this.props.onRefreshStatus}
                    onClearAllUploaded={this.props.onClearAllUploaded}
                    mfilesUpload={this.props.mfilesUpload}
                    onFilesChange2={this.props.onFilesChange2}
                    onFilesError2={this.props.onFilesError2}
                    mprogress={this.props.mprogress}
                    msending={this.props.msending}
                    onSelectFile={this.props.onSelectFile}
                    onSelectAllFile={this.props.onSelectAllFile}
                    orderDataTat={this.props.orderDataTat}
                    orderDataManufacturer={this.props.orderDataManufacturer}
                    mlabData={this.props.mlabData}
                    mlabChosen={this.props.mlabChosen}
                    mbranchData={this.props.mbranchData}
                    mbranchType={this.props.mbranchType}
                    saveTatType={this.props.saveTatType}
                    saveMessegeOrder={this.props.saveMessegeOrder}
                    saveManufactType={this.props.saveManufactType}
                    saveDesignSoftware={this.props.saveDesignSoftware}
                    saveOrderModel={this.props.saveOrderModel}
                    saveDesignApproval={this.props.saveDesignApproval}
                    saveIsBravo={this.props.saveIsBravo}
                    saveBranchType={this.props.saveBranchType}
                    saveLabselected={this.props.saveLabselected}
                    saveDrPreferences={this.props.saveDrPreferences}
                    saveBookingId={this.props.saveBookingId}
                />

                {/* <------------------------------------------------------Error Message---------------------------------> */}
                <Snackbar
                    open={this.props.errorBar}
                    onClose={this.props.handleCloseRemovefiles}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Alert
                        severity="error"
                        onClose={this.props.handleCloseRemovefiles}
                    >
                        <AlertTitle>Error</AlertTitle>
                        {this.props.errorMessage}
                    </Alert>
                </Snackbar>
                {/* <------------------------------------------------------Success Message---------------------------------> */}
                <Snackbar
                    open={this.props.successBar}
                    onClose={this.props.handleCloseRemovefiles}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Alert
                        severity="success"
                        onClose={this.props.handleCloseRemovefiles}
                    >
                        <AlertTitle>Success</AlertTitle>
                        {this.props.successMessage}
                    </Alert>
                </Snackbar>
            </div>

        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }
}

export default MFilesTable;



// WEBPACK FOOTER //
// ./src/components/MfilesTable/MFilesTable.tsx